<div class="container-fluid p-3" [ngStyle]="{'height': scrHeight}" style="overflow: auto;">
  <div class="card mb-3">
    <div class="card-body py-2 px-3">
      <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <button class="btn pill-btn flex-shrink-0" (click)="goBack()" matTooltip="Back to Dashboard">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <span class="text-muted cursor-pointer d-none d-md-inline" (click)="goBack()">Back to Dashboard</span>
          <span class="text-muted d-none d-md-inline">|</span>
          <span class="project-id-link fs-6">{{ projectName }}</span>
        </div>

        <app-tutorial-video-widget
          screenId="dashboard-detailed-screen"
          title="Project Detail walkthrough"
          teaserDescription="Watch a quick walkthrough of this screen."
          storageKey="dashboard-detailed-screen-tutorial-seen"
          teaserPosition="bottom-right"
          launcherPosition="bottom-right"
          [autoPlaySequence]="adminTutorialSequence"
          [allowLauncherDismiss]="true">
        </app-tutorial-video-widget>
        <div class="d-flex align-items-center gap-2">
          <button class="btn pill-btn flex-shrink-0" (click)="reloadPage()" title="Refresh">
            <mat-icon>refresh</mat-icon>
          </button>
          <span class="badge padding" [ngClass]="getStatusClass(projectDetails.status)" *ngIf="projectDetails.status">
            {{ projectDetails.status }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="row g-3">
    <!-- Left Column -->
    <div class="col-12 col-lg-8">
      <!-- Project Overview Card -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="page-title mb-4 ">Project Overview</div>

          <div class="row g-3">
            <div class="col-6 col-md-6">
              <label class="form-label text-muted small mb-1">Project Name</label>
              <p class="mb-0 left-content-text">{{ projectDetails.projectName }}</p>
            </div>
            <div class="col-6 col-md-6">
              <label class="form-label text-muted small  mb-1">Contact Person</label>
              <p class="mb-0 left-content-text">{{ projectDetails.contactPerson }}</p>
            </div>

            <div class="col-6 col-md-6">
              <label class="form-label text-muted small  mb-1">Due Date</label>
              <p class="mb-0 d-flex align-items-center gap-2 left-content-text">
                <mat-icon class="text-muted icon-left">calendar_today</mat-icon>
                {{ projectDetails.dueDate | date:'MMM d, yyyy':'UTC' }}
              </p>
            </div>
            <div class="col-6 col-md-6">
              <label class="form-label text-muted small mb-1">Last Updated</label>
              <p class="mb-0 d-flex align-items-center gap-2 left-content-text">
                <mat-icon class="text-muted icon-left">schedule</mat-icon>
                {{ projectDetails.lastUpdated | date:'MM/dd/yyyy hh:mm a' }}
              </p>
            </div>
            <div class="col-6 col-md-6">
              <label class="form-label text-muted small  mb-1">Task Progress</label>
              <p class="mb-0 d-flex align-items-center gap-2 left-content-text">
                <mat-icon class="text-success icon-left">check_circle</mat-icon>
                {{ projectDetails.taskProgress?.completed || 0 }}/{{ projectDetails.taskProgress?.total || 0 }}
                completed
              </p>
            </div>
          </div>

          <!-- Progress Bar -->
          <div class="border-top mt-4 pt-4">
            <div class="d-flex justify-content-between mb-2">
              <span class="left-content-text">Overall Progress</span>
              <span class="left-content-text">{{ projectDetails.overallProgress }}%</span>
            </div>
            <div class="progress" style="height: 8px;">
              <div class="progress-bar bg-success" role="progressbar" [style.width.%]="projectDetails.overallProgress"
                [attr.aria-valuenow]="projectDetails.overallProgress" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <!-- Sub Tasks & Activity Tracking / File Versions Section -->
      <div class="card mb-3">
        <div class="card-body">
          <!-- Header with Card Title -->
          <div class="card-title mb-3">Sub Tasks & Activity Tracking
            <span>
              <button class="download-all-btn" (click)="downloadAllFiles()" title="Download All Files" [disabled]="isDownloadAllDisabled">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 15V3"></path>
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <path d="m7 10 5 5 5-5"></path>
                </svg>
                Download All
              </button>
            </span>
          </div>
          
          <!-- No results message -->
          <div *ngIf="filteredSubTasks.length === 0 && subTasks.length > 0" class="text-center text-muted py-4">
            <mat-icon class="mb-2" style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">filter_list_off</mat-icon>
            <p class="mb-0">No tasks match the selected filters</p>
          </div>
          
          <!-- Activity Log View -->
          <div class="d-flex flex-column gap-3">
            <div class="sub-task-card" *ngFor="let task of filteredSubTasks">
              <!-- Task Header -->
              <div class="sub-task-header" (click)="toggleTaskExpand(task.taskId)">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <span class="sub-task-heading text-primary ">{{ task.department }}</span>
                </div>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <!-- Status Badge with Icon -->
                  <span class="status-badge" [ngClass]="getStatusClass(task.status)">
                    <mat-icon class="status-icon" *ngIf="task.status === 'IN PROGRESS'">trending_up</mat-icon>
                    <mat-icon class="status-icon" *ngIf="task.status === 'NO RESPONSIBILITY'">warning</mat-icon>
                    <mat-icon class="status-icon" *ngIf="task.status === 'NO CHANGES REQUIRED'">check_circle</mat-icon>
                    <span class="status-text">{{ task.status }}</span>
                  </span>
                  <!--<span class="badge bg-light text-purple d-flex align-items-center gap-1">
                    <mat-icon class="icon-small ">trending_up</mat-icon>
                    <div style="font-size: 12px;">{{ task.activities }} Activities</div>
                  </span>-->
                  <mat-icon class="expand-icon"
                    [style.transform]="expandedTaskId === task.taskId ? 'rotate(180deg)' : 'rotate(0deg)'">
                    expand_more
                  </mat-icon>
                </div>
              </div>

              <!-- Task Title -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="sub-task-title left-content-text">Assigned to - {{ task.assignedTo }}</div>
                <div class="sub-task-title left-content-text" *ngIf="task.status === 'Pending RRE Review'">RRE-{{ task.rreName || 'Unassigned' }}</div>
                <div class="sub-task-title left-content-text" *ngIf="task.status === 'Pending RAES Review'">RRE-{{ task.rreName || 'Unassigned' }}</div>
                <div class="sub-task-title left-content-text" *ngIf="task.status === 'Completed'">RRE-{{ task.rreName || 'Unassigned' }}</div>
              </div>

              <!-- Status Message Alert - Only shows when expanded -->
              <div *ngIf="expandedTaskId === task.taskId && getStatusMessage(task.status)" 
                   [ngClass]="task.status === 'NO CHANGES REQUIRED' ? 'alert alert-no-changes' : 'alert alert-no-responsibility'" 
                   role="alert">
                {{ getStatusMessage(task.status) }}
              </div>

              <!-- Expanded Details -->
              <div *ngIf="expandedTaskId === task.taskId" class="sub-task-details">
                <!-- Single Row with 3 Columns -->
                <div class="row g-3">
                  <div class="col-12 col-sm-6 col-md-4" *ngIf="task.assignedTo">
                    <div class="detail-chip-card">
                      <div class="chip-label">Assigned to</div>
                      <div class="chip-value">{{ task.assignedTo }}</div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4" *ngIf="task.lastUpdated">
                    <div class="detail-chip-card">
                      <div class="chip-label">Last Updated</div>
                      <div class="chip-value">{{ task.lastUpdated | date:'MM/dd/yyyy hh:mm a'}}</div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4">
                    <div class="detail-chip-card">
                      <div class="chip-label">Activity Count</div>
                      <div class="chip-value">{{ task.activities }} updates</div>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons (Email Reminder, Escalate, Change Assignee) - Only for regular statuses -->
                <div class="button-row-3-col mt-3" *ngIf="task.status !== 'Completed' && task.status !== 'Pending RAES Review'">
                  <!-- Email Reminder Button -->
                  <button class="btn btn-action btn-email d-flex align-items-center gap-2" (click)="openEmailReminderModal(task)">
                    <mat-icon>mail_outline</mat-icon>
                    <span>Email Reminder</span>
                  </button>

                  <!-- Escalate Button -->
                  <button class="btn btn-action btn-escalate d-flex align-items-center gap-2" (click)="openEscalateModal(task)">
                    <mat-icon>warning</mat-icon>
                    <span>Escalate</span>
                  </button>

                  <!-- Change Assignee Button -->
                  <button class="btn btn-action btn-assignee d-flex align-items-center gap-2" (click)="openChangeAssigneeModal(task)">
                    <mat-icon>person_outline</mat-icon>
                    <span>Change Assignee</span>
                  </button>
                </div>

                <!-- Activity Log and View Files Buttons - For ALL statuses -->
                <div class="button-row-50-50 mt-3">
               
                  <button class="btn btn-danger btn-half" (click)="viewActivityStream(task.taskId)">
                    <mat-icon>trending_up</mat-icon>
                    <span class="button-text">{{ showActivityStream[task.taskId] ? 'Hide Activity Log' : 'View Activity Log' }}</span>
                    <span class="badge bg-light text-danger ms-1 mt-1">Activity count: {{ (task.activityStreamData && task.activityStreamData.length) || 0 }}</span>
                  </button>
                  
                  
                  <button class="btn btn-danger btn-half" (click)="handleViewFileVersions(task)">
                   <mat-icon>description</mat-icon>
                    <span class="button-text">
                      {{ showFileVersions[task.taskId] ? 'Hide Uploaded File Versions' : (task.status === 'Pending RAES Review' ? 'View Uploaded Files & Review' : 'View Uploaded File Versions') }}
                    </span>
                    <span class="badge bg-light text-danger ms-1 mt-1">Files count: {{ (task.uploadedDocumentsData && task.uploadedDocumentsData.length) || 0 }}</span>
                  </button>
                </div>

                

                <!-- Change Assignee Button for NO RESPONSIBILITY - Full width -->
                <div class="mt-3" *ngIf="task.status === 'NO RESPONSIBILITY'">
                  <button class="btn btn-action btn-assignee w-100 d-flex align-items-center justify-content-center gap-2" (click)="openChangeAssigneeModal(task)">
                    <mat-icon>person_outline</mat-icon>
                    <span>Change Assignee</span>
                  </button>
                </div>

                <!-- Escalate Task Modal -->
                <div class="modal fade" tabindex="-1" role="dialog" [class.show]="showEscalateModal" [style.display]="showEscalateModal ? 'block' : 'none'">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-custom" role="document">
                    <div class="modal-content">
                      <div class="modal-header modal-header-custom">
                        <div class="modal-header-content">
                          <div class="modal-icon-box">
                            <mat-icon>warning</mat-icon>
                          </div>
                          <div class="modal-title-custom">Escalate Task</div>
                        </div>
                        <button type="button" class="close-btn" (click)="closeEscalateModal()" title="Cancel">✕</button>
                      </div>
                      <div class="modal-body">
                        
                        <!-- Current Assignee (Read-only) -->
                        <div class="mb-3">
                          <label class="form-label small mb-2">Current Assignee</label>
                          <input type="text" class="form-control assignee-input assignee-readonly-input assignee-disabled" value="{{ currentTask?.assignedTo }}" readonly>
                        </div>

                        <!-- Escalate To Editable Input and Selection -->
                        <div class="mb-3">
                          <label class="form-label small mb-2">Escalate To <span class="text-danger">*</span></label>
                          <input type="text" class="form-control placeholder-style" placeholder="Enter manager email..." [(ngModel)]="escalateToField" (input)="onEscalateInput()">
                        </div>

                        <div class="mb-3" *ngIf="searchEscalateQuery.trim()">
                          <label class="form-label small mb-2">Available Managers/Leads</label>
                          <div class="available-users-list">
                            <div *ngFor="let user of filteredEscalationTargets"
                                 (click)="selectEscalationTarget(user)"
                                 class="p-3 user-list-item"
                                 [class.user-list-item-selected]="escalateToField === (user.manager_email || user.email_address || user.email)">
                              <div class="small user-name">{{ user.tm_name }} <span class="text-muted">- {{ user.email_address || user.email }}</span></div>
                              <div class="text-muted small">{{ user.job_title }} (Level: {{ user.management_level }})</div>
                            </div>
                            <div *ngIf="filteredEscalationTargets.length === 0" class="p-3 text-muted text-center no-results-message">
                              No team members found matching your search.
                            </div>
                          </div>
                        </div>

                        <div class="mb-3">
                          <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="form-label small mb-0">CC</label>
                            <button
                              type="button"
                              class="cc-clear-all-btn"
                              *ngIf="selectedCcEmails.length > 0"
                              (click)="clearAllCcEmails()">
                              Clear All
                            </button>
                          </div>
                          <div class="cc-chips-container">
                            <span *ngFor="let email of selectedCcEmails" 
                                  class="cc-chip"
                                  (click)="toggleCcEmail(email)">
                              <mat-icon class="cc-chip-icon">email</mat-icon>
                              <span>{{ email }}</span>
                              <span class="cc-chip-close">&times;</span>
                            </span>
                            <input
                              type="email"
                              class="cc-input-field"
                              placeholder="Type an email and press Enter…"
                              [(ngModel)]="escalateCcInput"
                              (keydown)="handleEscalateCcInput($event)"
                              (blur)="addEscalateCcEmail()" />
                          </div>
                          <small class="form-text text-muted" style="font-size: 12px; margin-top: 4px;">Press Enter or comma to add an email address</small>
                        </div>

                        <!-- Available Escalation Targets (Commented Out)
                        <div class="mb-3">
                          <label class="form-label small mb-2">Available Managers/Leads</label>
                          <div class="search-input-wrapper escalation-search-wrapper">
                            <mat-icon class="search-icon escalation-search-icon">search</mat-icon>
                            <input type="text" class="form-control search-input escalation-search-input" placeholder="Search by name or role..." [(ngModel)]="searchEscalateQuery">
                          </div>
                        </div>
                        -->

                        <!-- Escalation Targets List (Commented Out)
                        <div class="mb-3">
                          <div class="available-users-list">
                            <div *ngFor="let user of filteredEscalationTargets" (click)="selectEscalationTarget(user)" class="p-3 user-list-item" [class.user-list-item-selected]="escalateToField === user.manager_email">
                              <div class="small user-name">{{ user.tm_name }}</div>
                              <div class="text-muted small">{{ user.job_title }} (Level: {{ user.management_level }})</div>
                            </div>
                            <div *ngIf="filteredEscalationTargets.length === 0" class="p-3 text-muted text-center no-results-message">
                              No team members found matching your search.
                            </div>
                          </div>
                        </div>
                        -->

                        <!-- Priority Level Dropdown -->
                        <div class="mb-3">
                          <label class="form-label small mb-2">Priority Level</label>
                          <select class="form-select form-select-custom" [(ngModel)]="escalationPriorityLevel">
                            <option value="">Select Priority Level</option>
                            <option value="Low">Low</option>
                            <option value="Medium">Medium</option>
                            <option value="High">High</option>
                            <option value="Critical">Critical</option>
                          </select>
                        </div>

                       
                        <div class="mb-3">
                          <label class="form-label small mb-2">Subject <span class="text-danger">*</span></label>
                          <input type="text" class="form-control placeholder-style" placeholder="Subject for this escalation…" [(ngModel)]="escalationReason">
                        </div>

                        <!-- Email Content with ngx-editor -->
                        <div style="flex: 1; display: flex; flex-direction: column;">
                          <label class="form-label small mb-2">Escalation Message <span class="text-danger">*</span></label>
                          <div class="email-content-editor form-row-textarea" style="border: 1px solid #e5e7eb; border-radius: 6px; overflow: hidden; flex: 1;">
                            <ngx-editor-menu [editor]="escalationEditor" [toolbar]="toolbar"></ngx-editor-menu>
                            <ngx-editor [editor]="escalationEditor" [formControl]="escalationReasonControl" placeholder="Enter escalation message…"></ngx-editor>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer modal-footer-custom">
                        <button type="button" class="btn btn-cancel" (click)="closeEscalateModal()">Cancel</button>
                        <button type="button" class="btn btn-action-primary" (click)="submitEscalate()" [disabled]="!canSubmitEscalate()">Escalate Task</button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Modal Backdrop -->
                <div class="modal-backdrop fade" [class.show]="showEscalateModal" [style.display]="showEscalateModal ? 'block' : 'none'"></div>

                <!-- Change Assignee Modal -->
                <div class="modal fade" tabindex="-1" role="dialog" [class.show]="showChangeAssigneeModal" [style.display]="showChangeAssigneeModal ? 'block' : 'none'">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-custom" role="document">
                    <div class="modal-content">
                      <div class="modal-header modal-header-custom">
                        <div class="modal-header-content">
                          <div class="modal-icon-box">
                            <mat-icon>person</mat-icon>
                          </div>
                          <div class="modal-title-custom">Change Assignee</div>
                        </div>
                        <button type="button" class="close-btn" (click)="closeChangeAssigneeModal()" title="Cancel">✕</button>
                      </div>
                      <div class="modal-body">
                        
                        <div class="mb-3">
                          <label class="form-label small mb-2">Current Assignee</label>
                          <input type="text" class="form-control assignee-input assignee-readonly-input assignee-disabled" [value]="currentTask?.assignedTo" readonly>
                        </div>

                        <!-- Search New Assignee -->
                        <div class="mb-3">
                          <label class="form-label small mb-2">Search New Assignee</label>
                          <div class="search-input-wrapper">
                            <mat-icon class="search-icon">search</mat-icon>
                            <input type="text" class="form-control search-input" placeholder="Search by name or email..." [(ngModel)]="searchAssigneeQuery" (input)="onAssigneeSearchInput()">
                          </div>
                        </div>

                        <!-- Selected Assignee -->
                        <div class="mb-3" *ngIf="selectedNewAssignee">
                          <label class="form-label small mb-2">Selected Assignee</label>
                          <div class="selected-item-box assignee-disabled">
                            <div class="small selected-item-name">{{ selectedNewAssignee.tm_name }}</div>
                            <div class="text-muted small">{{ selectedNewAssignee.email }}</div>
                          </div>
                        </div>

                        <!-- Available Users -->
                        <div class="mb-3">
                          <label class="form-label small mb-2">Available Members</label>
                          <div class="available-users-list">
                            <div *ngFor="let user of filteredUsers" (click)="selectAssignee(user)" class="p-3 user-list-item" [class.user-list-item-selected]="selectedNewAssignee?.tm_name === user.tm_name">
                              <div class="small user-name">{{ user.tm_name }} <span class="text-muted">- {{ user.email }}</span></div>
                              <div class="text-muted small">{{ user.department }}</div>
                            </div>
                            <div *ngIf="filteredUsers.length === 0" class="p-3 text-muted text-center no-results-message">
                              No users found matching your search.
                            </div>
                          </div>
                        </div>

                       
                        <div class="mb-3">
                          <label class="form-label small mb-2">Transfer Notes (Optional)</label>
                          <textarea class="form-control no-focus-border form-textarea-custom" rows="4" placeholder="Add any notes about this transfer..." [(ngModel)]="transferNotes"></textarea>
                        </div>

                      </div>
                      <div class="modal-footer modal-footer-custom">
                        <button type="button" class="btn btn-cancel" (click)="closeChangeAssigneeModal()">Cancel</button>
                        <button type="button" class="btn btn-action-primary" (click)="submitChangeAssignee()" [disabled]="!selectedNewAssignee">Change Assignee</button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Modal Backdrop -->
                <div class="modal-backdrop fade" [class.show]="showChangeAssigneeModal" [style.display]="showChangeAssigneeModal ? 'block' : 'none'"></div>

                <!-- Send Email Reminder Modal -->
                <div class="modal fade" tabindex="-1" role="dialog" [class.show]="showEmailReminderModal" [style.display]="showEmailReminderModal ? 'block' : 'none'">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-custom" role="document">
                    <div class="modal-content">
                      <div class="modal-header modal-header-custom">
                        <div class="modal-header-content">
                          <div class="modal-icon-box">
                            <mat-icon>mail_outline</mat-icon>
                          </div>
                          <div class="modal-title-custom">Send Email Reminder</div>
                        </div>
                        <button type="button" class="close-btn" (click)="closeEmailReminderModal()" title="Cancel">✕</button>
                      </div>
                      <div class="modal-body">
                        
                        <!-- Recipient -->
                        <div class="mb-3">
                          <div>
                            <label class="form-label small mb-2">To <span class="text-danger">*</span></label>
                            <input type="text" class="form-control placeholder-style" placeholder="Enter email address..."
                              [(ngModel)]="emailReminderToAddress" (input)="onEmailReminderToInput()">
                          </div>
                          <small class="form-text text-muted" style="font-size: 12px; margin-top: 4px;">Use a comma to
                            separate multiple email addresses</small>
                        </div>

                        <div class="mb-3" *ngIf="emailReminderSearchTerm">
                          <label class="form-label small mb-2">Available Members</label>
                          <div class="available-users-list">
                            <div *ngFor="let user of availableEmailReminderRecipients"
                                 (click)="selectEmailReminderRecipient(user)"
                                 class="p-3 user-list-item">
                              <div class="small user-name">{{ user.tm_name }} <span class="text-muted">- {{ user.email }}</span></div>
                              <div class="text-muted small">{{ user.department }}</div>
                            </div>
                            <div *ngIf="availableEmailReminderRecipients.length === 0" class="p-3 text-muted text-center no-results-message">
                              No users found matching your search.
                            </div>
                          </div>
                        </div>

                        <div class="mb-3">
                          <label class="form-label small mb-2">CC</label>
                          <div class="cc-container">
                            <span class="cc-badge"
                              *ngFor="let email of emailReminderCcArray; let i = index">
                              <span>{{ email }}</span>
                              <button type="button"
                                class="cc-badge-close"
                                (click)="removeCcEmailReminder(i)"
                                title="Click to remove"
                                aria-label="Remove">✕</button>
                            </span>
                            <input type="email" 
                              class="cc-input-field email-input-fade"
                              placeholder="Add email addresses..." 
                              [(ngModel)]="emailReminderCcInput"
                              (input)="onEmailReminderCcInput()"
                              (keydown)="handleCcInput($event)" />
                          </div>
                          <div class="available-users-list mt-2" *ngIf="emailReminderCcSearchTerm">
                            <div *ngFor="let user of availableEmailReminderCcRecipients"
                                 (click)="selectEmailReminderCcRecipient(user)"
                                 class="p-3 user-list-item">
                              <div class="small user-name">{{ user.tm_name }} <span class="text-muted">- {{ user.email }}</span></div>
                              <div class="text-muted small">{{ user.department }}</div>
                            </div>
                            <div *ngIf="availableEmailReminderCcRecipients.length === 0" class="p-3 text-muted text-center no-results-message">
                              No users found matching your search.
                            </div>
                          </div>
                          <small class="form-text text-muted" style="font-size: 12px; margin-top: 4px;">Press Enter or comma to add multiple email addresses</small>
                        </div>

                        <!-- Subject -->
                        <div class="mb-3">
                          <label class="form-label small mb-2">Subject <span class="text-danger">*</span></label>
                          <input type="text" class="form-control placeholder-style" placeholder="Reminder: Task pending..." [(ngModel)]="emailReminderSubject">
                        </div>

                        <!-- Message with ngx-editor -->
                        <div style="flex: 1; display: flex; flex-direction: column;">
                          <label class="form-label small mb-2">Message <span class="text-danger">*</span></label>
                          <div class="email-message-editor form-row-textarea" style="border: 1px solid #e5e7eb; border-radius: 6px; overflow: hidden; flex: 1;">
                            <ngx-editor-menu [editor]="emailMessageEditor" [toolbar]="toolbar"></ngx-editor-menu>
                            <ngx-editor [editor]="emailMessageEditor" [formControl]="emailMessageControl"></ngx-editor>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer modal-footer-custom">
                        <button type="button" class="btn btn-cancel" (click)="closeEmailReminderModal()">Cancel</button>
                        <button type="button" class="btn btn-action-primary" (click)="sendEmailReminder()" [disabled]="!canSendEmailReminder()">Send Reminder</button>
                      </div>
                    </div>
                  </div>
                </div>

               
                <div class="modal-backdrop fade" [class.show]="showEmailReminderModal" [style.display]="showEmailReminderModal ? 'block' : 'none'"></div>

                <!-- Activity Stream Section -->
                <div *ngIf="showActivityStream[task.taskId]" class="activity-stream-section">
                  <div class="activity-stream-header">
                    <div class="mb-0 activity-timeline-title">Activity Timeline For <span class="text-primary">{{ task.department }}</span></div>
                    <div class="activity-timeline-title" style="font-size: 13px; font-weight: 500; color: #6b7280;">{{ task.activityStreamData?.length || 0 }} total activities</div>
                  </div>
                  <div class="activity-title-divider"></div>

                  <div class="activity-list">
                    <div *ngIf="task.activityStreamData === null" class="activity-loading">
                      <div class="spinner"></div>
                      <span>Loading activities...</span>
                    </div>
                    
                    
                    <ng-container *ngIf="task.activityStreamData !== null && task.activityStreamData.length > 0">
                      <div class="activity-item-wrapper" *ngFor="let activity of task.activityStreamData; let last = last; let first = first">
                        <div class="activity-divider" *ngIf="!first"></div>
                        <div class="activity-content-row">
                          <div class="activity-timeline-line" [class.last-item]="last">
                            <!-- Different icons based on activity type -->
                            <div class="activity-user-avatar" [ngClass]="'avatar-' + getActivityIconType(activity)" [ngSwitch]="getActivityIconType(activity)">
                              <!-- Assigned - User Check icon -->
                              <svg *ngSwitchCase="'assigned'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <polyline points="16 11 18 13 22 9"></polyline>
                              </svg>
                              <!-- Approved - Circle Check Big icon -->
                              <svg *ngSwitchCase="'approved'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                                <path d="m9 11 3 3L22 4"></path>
                              </svg>
                              <!-- File Uploaded - Cloud Upload icon -->
                              <svg *ngSwitchCase="'file-uploaded'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="16 16 12 12 8 16"></polyline>
                                <line x1="12" y1="12" x2="12" y2="21"></line>
                                <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path>
                              </svg>
                              <!-- File Deleted - Trash icon -->
                              <svg *ngSwitchCase="'file-deleted'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                              </svg>
                              <!-- Rework - Send icon -->
                              <svg *ngSwitchCase="'rework'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                                <path d="m21.854 2.147-10.94 10.939"></path>
                              </svg>
                              <!-- Comment - Message Square icon -->
                              <svg *ngSwitchCase="'comment'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                              </svg>
                              <!-- Escalation - Warning triangle icon -->
                              <svg *ngSwitchCase="'escalation'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                                <path d="M12 9v4"></path>
                                <path d="M12 17h.01"></path>
                              </svg>
                              <!-- Reminder - Mail icon -->
                              <svg *ngSwitchCase="'reminder'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                              </svg>
                              <!-- Skip - Skip Forward icon -->
                              <svg *ngSwitchCase="'skip'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polygon points="5 4 15 12 5 20 5 4"></polygon>
                                <line x1="19" x2="19" y1="5" y2="19"></line>
                              </svg>
                              <svg *ngSwitchCase="'status-update'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                                <path d="M3 3v5h5"></path>
                                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"></path>
                                <path d="M16 16h5v5"></path>
                              </svg>
                              <!-- RRE Review - Eye with check icon -->
                              <svg *ngSwitchCase="'rre-review'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                                <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                              <!-- Default - Activity pulse icon -->
                              <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor">
                                <path d="M360-160q-19 0-34-11t-22-28l-92-241H40v-80h228l92 244 184-485q7-17 22-28t34-11q19 0 34 11t22 28l92 241h172v80H692l-92-244-184 485q-7 17-22 28t-34 11Z"/>
                              </svg>
                            </div>
                          </div>
                          <div class="activity-item">
                            <div class="activity-header">
                              <div class="activity-user-info">
                                <span class="activity-user">{{ activity.user_name || activity.created_by }}</span>
                              </div>
                              <div class="activity-timestamp-top">
                                <svg class="timestamp-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                                <span class="activity-timestamp">{{ activity.created_at | date:'MM/dd/yyyy hh:mm a' }}</span>
                              </div>
                            </div>
                            <p class="activity-message" *ngIf="activity.activity_description && !hasComments(activity)"><span class="activity-label">Activity:</span> {{ activity.activity_description }}</p>
                            <p class="activity-message" *ngIf="hasComments(activity) && activity.activity_description"><span class="activity-label">Activity:</span> {{ activity.activity_description }}</p>
                            <p class="activity-message-comment" *ngIf="hasComments(activity)"><span class="comment-label">Comment:</span> {{ activity.user_comments }}</p>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    
                   
                    <div *ngIf="task.activityStreamData !== null && task.activityStreamData.length === 0" class="text-muted text-center p-3">
                      <mat-icon class="mb-2">info_outline</mat-icon>
                      <p>No activity found</p>
                    </div>
                  </div>

                  <div class="activity-comment-composer" *ngIf="projectDetails.status !== 'Completed'">
                    <div class="d-flex align-items-center gap-2">
                      <input
                        type="text"
                        class="form-control activity-comment-input"
                        [(ngModel)]="newActivityComment[task.taskId]"
                        placeholder="Add your review comment..."
                        (keydown.enter)="postActivityComment(task)"
                      />
                      <button
                        type="button"
                        class="btn btn-action-primary activity-send-btn"
                        [disabled]="!newActivityComment[task.taskId] || !newActivityComment[task.taskId].trim()"
                        (click)="postActivityComment(task)"
                        matTooltip="Send"
                      >
                        <mat-icon>send</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <div *ngIf="showFileVersions[task.taskId]" class="file-versions-section">
                  <div *ngIf="task.uploadedDocumentsData === null" class="activity-loading">
                    <div class="spinner"></div>
                    <span>Loading files...</span>
                  </div>
                  
                  <ng-container *ngIf="task.uploadedDocumentsData !== null && task.uploadedDocumentsData.length > 0">
                    <div class="file-versions-header">
                      <div class="mb-0 " style="font-size: 13px;">File Versions For <span class="sub-task-heading text-primary">{{ task.department }}</span></div>
                      <div class="file-header-right-group">
                        <span class="file-count-text" style="font-size: 12px;">{{ task.uploadedDocumentsData.length }} total files</span>
                      </div>
                    </div>
                    <div class="file-versions-divider"></div>

                    <div *ngFor="let file of task.uploadedDocumentsData; let last = last" class="file-card-wrapper">
                    <div class="file-header-card" (click)="toggleFileExpand(file.fileId)"
                         [class.expanded]="expandedFileIds.has(file.fileId)">
                      <div class="file-left-content">
                        <mat-icon class="file-toggle-icon"
                                  [style.transform]="expandedFileIds.has(file.fileId) ? 'rotate(180deg)' : 'rotate(0deg)'">
                          expand_more
                        </mat-icon>
                        <!-- File Icon based on file type -->
                        <ng-container [ngSwitch]="getFileIconType(file.fileName)">
                          <!-- PDF Icon -->
                          <svg *ngSwitchCase="'pdf'" width="20" height="20" viewBox="0 0 24 24"
                               xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#ef4444"
                               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                               aria-hidden="true" class="file-type-icon">
                            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                          </svg>

                          <!-- XLS Icon -->
                          <svg *ngSwitchCase="'xls'" width="20" height="20" viewBox="0 0 24 24"
                               xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#10b981"
                               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                               aria-hidden="true" class="file-type-icon">
                            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                          </svg>

                          <!-- DOC Icon -->
                          <svg *ngSwitchCase="'doc'" width="20" height="20" viewBox="0 0 24 24"
                               xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#2563eb"
                               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                               aria-hidden="true" class="file-type-icon">
                            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                          </svg>

                          <!-- IMAGE Icon -->
                          <svg *ngSwitchCase="'image'" width="20" height="20" viewBox="0 0 24 24"
                               xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#7c3aed"
                               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                               aria-hidden="true" class="file-type-icon">
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                            <circle cx="9" cy="9" r="2"></circle>
                            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                          </svg>

                          <!-- DEFAULT Icon -->
                          <svg *ngSwitchDefault width="20" height="20" viewBox="0 0 24 24"
                               xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#7c3aed"
                               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                               aria-hidden="true" class="file-type-icon">
                            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                          </svg>
                        </ng-container>
                        <span class="file-title">{{ file.fileName }}</span>
                      </div>

                      <!-- Right Side: Version Count and Latest Badge -->
                      <div class="file-right-content">
                        <span class="badge bg-light text-muted">Current status: <span
                            [ngClass]="{ 'text-muted': file.document_status == 'Not Started', 'text-success': file.document_status && file.document_status !== 'Not Started' }">{{
                            file.document_status }}</span></span>
                            <span class="badge bg-light text-muted">Total versions:<span class="text-primary">&nbsp; {{ file.versions.length
                                }}</span></span>
                      </div>
                    </div>

                    <!-- File Versions Table (Expanded Content) -->
                    <div *ngIf="expandedFileIds.has(file.fileId)" class="file-versions-table-wrapper">
                      <table class="table table-sm table-hover mb-0">
                        <thead class="table-light">
                          <tr>
                            <th class="col-version">VERSION</th>
                            <th class="col-uploaded">UPLOADED BY</th>
                            <th class="col-filename">FILE NAME</th>
                            <th class="col-date">UPLOAD DATE & TIME</th>
                            <th class="col-actions" >ACTIONS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let version of file.versions" [class.latest-version]="version.isLatest">
                            <td class="col-version">
                              <span class="version-number">{{ version.versionNumber }}</span>
                              <span *ngIf="version.isLatest" class="badge bg-success ms-2">Latest</span>
                            </td>
                            <td class="col-uploaded">
                              <div class="uploader-info">
                                <div class="uploader-name">{{ version.uploadedBy }}</div>
                                <div class="uploader-role">{{ version.role }}</div>
                              </div>
                            </td>
                            <td class="col-filename">
                              <span class="file-name-text" title="{{ version.file_name }}">{{ version.file_name }}</span>
                            </td>
                            <td class="col-date">
                              <div class="date-time">
                                {{ version.uploadedAt | date:'MM/dd/yyyy hh:mm a' }}
                              </div>
                            </td>
                            <td class="col-actions">
                              <button class="btn icon-btn icon-btn-lg" 
                                      title="View file"
                                      (click)="preview(version)">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                                        stroke="#374151" stroke-width="1.2" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                  <circle cx="12" cy="12" r="2.5" stroke="#374151" stroke-width="1.2"></circle>
                                </svg>
                              </button>

                              <button class="btn icon-btn icon-btn-lg" 
                                      title="Download file"
                                      (click)="download(version)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="1.2"
                                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                  <path d="M12 15V3"></path>
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <path d="m7 10 5 5 5-5"></path>
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Divider between files -->
                    <div *ngIf="!last" class="file-divider"></div>
                  </div>
                  </ng-container>
                  
                  
                  <div *ngIf="task.uploadedDocumentsData !== null && task.uploadedDocumentsData.length === 0" class="no-documents-empty-card">
                    <div class="no-documents-content">
                      <svg class="no-documents-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                        <line x1="9" y1="13" x2="15" y2="13"/>
                        <line x1="9" y1="17" x2="15" y2="17"/>
                      </svg>
                      <span class="no-documents-text">No documents to view</span>
                    </div>
                    <span class="badge bg-light text-muted no-documents-status">Current status: <span
                        [ngClass]="(task.noDocUploadsStatus || 'Not Started') === 'Not Started' ? 'text-muted' : 'text-success'"
                        class="no-documents-status-label">{{
                        task.noDocUploadsStatus || 'Not Started' }}</span></span>
                  </div>
                </div>

                <!-- Review Panel - Positioned after File Versions -->
                <div *ngIf="showReviewPanel && task.status === 'Pending RAES Review'" class="card mt-3 review-panel-card">
                  <div class="card-body">
                    <div class="d-flex align-items-center gap-3 mb-1">
                      <div class="review-panel-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="13 2 13 9 20 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="9" y1="15" x2="15" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="9" y1="11" x2="15" y2="11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <h5 class="card-title mb-0 review-panel-title">RAES Review Panel</h5>
                    </div>
                    <hr class="review-panel-divider">
                    
                    <p class="text-muted small mb-1 review-panel-description"> Please verify the submitted files and choose an appropriate action.</p>
                    
                    <div class="mb-3">
                      <label class="form-label small mb-1 review-comments-label">Review Comments <span class="text-danger">*</span></label>
                      <textarea class="form-control review-comments-textarea placeholder-fade" 
                                rows="3" 
                                placeholder="Add comments..."
                                [(ngModel)]="reviewComments"
                                (input)="reviewCommentsError = ''"></textarea>
                      <div *ngIf="reviewCommentsError" class="review-comments-error">
                        {{ reviewCommentsError }}
                      </div>
                    </div>

                    <div class="d-flex gap-2 review-buttons-container">
                      <button type="button" class="btn btn-success flex-grow-1 review-btn-approve" (click)="approveAndComplete()">
                        <mat-icon class="review-btn-icon">check_circle</mat-icon>
                        <span>Approve & Complete</span>
                      </button>
                      <button type="button" class="btn flex-grow-1 review-btn-rework" (click)="sendForRework()">
                        <mat-icon class="review-btn-icon">restart_alt</mat-icon>
                        <span>Send for Rework</span>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div *ngIf="subTasks.length === 0" class="text-center text-muted py-4">
              No tasks available
            </div>
          </div>
        </div>
      </div>

      <!-- Email Layout Preview Card -->
      <div class="card mb-3 email-layout-card" [hidden]="!hasEmailDetails">
        <div class="card-body">
          <div class="row g-3">
            <div class="page-title">Email Details</div>

            <div class="email-detail-row">
              <div class="email-detail-label">Subject</div>
              <div class="email-detail-value-box">
                <div class="email-detail-value">
                  {{emailDetails.subject}}
                </div>
              </div>
            </div>

            <div class="email-detail-row email-content-row mb-0">
              <div class="email-detail-label">Email Content</div>
              <div class="email-detail-value-box">
                <div class="email-detail-value">
                  <div class="email-content-preview" [innerHTML]="emailDetails.email_body">
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-12 col-lg-4">
      <!-- Departments Involved -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="card-title mb-3">Departments Involved</div>
          <div class="d-flex flex-column gap-2">
            <div class="d-flex align-items-center gap-2" *ngFor="let dept of departmentsInvolved">
              <mat-icon class="text-muted icon-right">groups</mat-icon>
              <span class="right-content-text">{{ dept.name }}</span>
            </div>
            <div *ngIf="departmentsInvolved.length === 0" class="text-muted small">
              No departments assigned
            </div>
          </div>
        </div>
      </div>

      <!-- Collection Details -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="card-title mb-3">Collection Overview</div>
          <div class="mb-3">
            <label class="form-label text-muted small mb-1">Collection Name</label>
            <div class="d-flex align-items-center gap-2">
              <mat-icon class="text-muted icon-right">folder_open</mat-icon>
              <span class="right-content-text">{{ collectionDetails.primaryCollection || 'Not assigned' }}</span>
            </div>
          </div>
          <div *ngIf="collectionDetails.subCollections?.length > 0">
            <label class="form-label text-muted small mb-1">Sub Collections</label>
            <div class="d-flex flex-column gap-2">
              <div class="d-flex align-items-center gap-2" *ngFor="let sub of collectionDetails.subCollections">
                <mat-icon class="text-muted icon-right">folder</mat-icon>
                <span class="right-content-text">{{ sub }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Stats -->
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="card-title mb-0">Status Overview</div>
            <div class="status-dropdown-container">
              <button class="status-dropdown-trigger" (click)="toggleStatusDropdown($event)">
                <span>{{ getSelectedStatusCount() > 0 ? getSelectedStatusCount() + ' Statuses' : 'All Status' }}</span>
                <mat-icon class="dropdown-arrow" [class.open]="isStatusDropdownOpen">expand_more</mat-icon>
              </button>
              <div class="status-dropdown-menu" *ngIf="isStatusDropdownOpen">
                <div class="status-dropdown-item checkbox-item" 
                     (click)="toggleAllStatuses($event)">
                  <div class="status-checkbox" [class.checked]="isAllStatusesSelected">
                    <mat-icon *ngIf="isAllStatusesSelected" class="checkbox-icon">check</mat-icon>
                  </div>
                  <span>Select All</span>
                </div>
                <div class="status-dropdown-item checkbox-item" 
                     *ngFor="let option of statusFilterOptions"
                     (click)="toggleStatusFilter(option, $event)">
                  <div class="status-checkbox" [class.checked]="isStatusSelected(option)">
                    <mat-icon *ngIf="isStatusSelected(option)" class="checkbox-icon">check</mat-icon>
                  </div>
                  <span>{{ option }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center stat-item"
              *ngFor="let stat of filteredQuickStats; let last = last">
              <div class="d-flex align-items-center gap-3 flex-grow-1">
                <div class="stat-icon-box" [style.backgroundColor]="getSoftBgColor(stat.color)">
                  <!-- Not Started SVG Icon -->
                  <svg *ngIf="stat.label === 'Not Started'" class="stat-svg-icon" [style.color]="getStatIconColor(stat.color)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                  </svg>
                  <!-- Assigned SVG Icon -->
                  <svg *ngIf="stat.label === 'Assigned'" class="stat-svg-icon" [style.color]="getStatIconColor(stat.color)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="8.5" cy="7" r="4"></circle>
                    <line x1="20" y1="8" x2="20" y2="14"></line>
                    <line x1="23" y1="11" x2="17" y2="11"></line>
                  </svg>
                  <!-- Default mat-icon for other statuses -->
                  <mat-icon *ngIf="stat.label !== 'Not Started' && stat.label !== 'Assigned'" class="stat-icon" [style.color]="getStatIconColor(stat.color)">{{ stat.icon }}</mat-icon>
                </div>
                <span class="right-content-text">{{ stat.label }}</span>
              </div>
              <span class="right-content-text fw-bold">{{ stat.count }}</span>
              <div class="stat-divider" *ngIf="!last"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Preview Modal -->
  <div class="position-fixed top-0 start-0 end-0 bottom-0 d-flex flex-column preview-overlay" *ngIf="isPreviewOpen">
    <div class="bg-white p-2 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <h6 class="mb-0 text-dark-primary">{{ previewTitle }}</h6>
      </div>
      <div class="d-flex align-items-center gap-3">
        <div *ngIf="previewType === 'xls'" class="d-flex align-items-center gap-2">
          <label class="small text-secondary me-1">Sheet</label>
          <select class="form-select form-select-sm" style="width:auto" [(ngModel)]="selectedSheetIndex"
                  (change)="renderSheetByIndex(selectedSheetIndex)">
            <option *ngFor="let s of sheetNames; let i = index" [ngValue]="i">{{ s }}</option>
          </select>
        </div>
        <button class="btn btn-light border-0 rounded-2 d-inline-flex align-items-center justify-content-center preview-close-btn" (click)="closePreview()" aria-label="Close preview">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#374151"
               stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>

    <div class="bg-white flex-grow-1 overflow-auto p-2">
      <iframe *ngIf="previewType === 'pdf'" [src]="previewUrl" width="100%" height="100%"></iframe>
      <img *ngIf="previewType === 'image'" [src]="previewUrl" alt="Image preview" class="preview-image" />
      <div *ngIf="previewType === 'docx'" #docxContainer class="h-100 overflow-auto"></div>
      <div *ngIf="previewType === 'xls'" [innerHTML]="excelHtml"></div>
      <!-- <div #webviewerContainer *ngIf="previewType === 'pptx'" style="width:100%;height:100%;min-height:600px;"></div> -->
      <p *ngIf="previewType === 'unsupported'" class="text-center text-secondary">Preview not supported for this file type.</p>
    </div>
  </div>
